export default __webpack_public_path__ + "static/media/LowCostIcon.baeff7a2.svg";